import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 24 24"
        ref={ref}
        {...props}
    >
        <mask id="ursa-icon__ExclamationAlertErrorIcon__24__ida" fill="#fff">
            <path
                fillRule="evenodd"
                d="M12 4.4a7.6 7.6 0 1 0 0 15.2 7.6 7.6 0 0 0 0-15.2M3 12a9 9 0 1 1 18 0 9 9 0 0 1-18 0"
                clipRule="evenodd"
            />
            <path
                fillRule="evenodd"
                d="M12 13.669a.7.7 0 0 0 .7-.7V8.694a.7.7 0 1 0-1.4 0v4.275a.7.7 0 0 0 .7.7"
                clipRule="evenodd"
            />
            <path d="M11.197 15.397a.803.803 0 1 0 1.606 0 .803.803 0 0 0-1.606 0" />
        </mask>
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M12 4.4a7.6 7.6 0 1 0 0 15.2 7.6 7.6 0 0 0 0-15.2M3 12a9 9 0 1 1 18 0 9 9 0 0 1-18 0"
            clipRule="evenodd"
        />
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M12 13.669a.7.7 0 0 0 .7-.7V8.694a.7.7 0 1 0-1.4 0v4.275a.7.7 0 0 0 .7.7"
            clipRule="evenodd"
        />
        <path fill="currentColor" d="M11.197 15.397a.803.803 0 1 0 1.606 0 .803.803 0 0 0-1.606 0" />
        <path
            fill="currentColor"
            d="M11.197 15.397h-1.5zM12 16.2v-1.5zm.803-.803h-1.5zM12 14.594v-1.5zM5.9 12A6.1 6.1 0 0 1 12 5.9v-3A9.1 9.1 0 0 0 2.9 12zm6.1 6.1A6.1 6.1 0 0 1 5.9 12h-3a9.1 9.1 0 0 0 9.1 9.1zm6.1-6.1a6.1 6.1 0 0 1-6.1 6.1v3a9.1 9.1 0 0 0 9.1-9.1zM12 5.9a6.1 6.1 0 0 1 6.1 6.1h3A9.1 9.1 0 0 0 12 2.9zm0-4.4C6.201 1.5 1.5 6.201 1.5 12h3A7.5 7.5 0 0 1 12 4.5zM22.5 12c0-5.799-4.701-10.5-10.5-10.5v3a7.5 7.5 0 0 1 7.5 7.5zM12 22.5c5.799 0 10.5-4.701 10.5-10.5h-3a7.5 7.5 0 0 1-7.5 7.5zM1.5 12c0 5.799 4.701 10.5 10.5 10.5v-3A7.5 7.5 0 0 1 4.5 12zm9.7.969a.8.8 0 0 1 .8-.8v3a2.2 2.2 0 0 0 2.2-2.2zm0-4.275v4.275h3V8.694zm.8.8a.8.8 0 0 1-.8-.8h3a2.2 2.2 0 0 0-2.2-2.2zm.8-.8a.8.8 0 0 1-.8.8v-3a2.2 2.2 0 0 0-2.2 2.2zm0 4.275V8.694h-3v4.275zm-.8-.8a.8.8 0 0 1 .8.8h-3a2.2 2.2 0 0 0 2.2 2.2zm-2.303 3.228A2.303 2.303 0 0 0 12 17.7v-3c.385 0 .697.312.697.697zM12 17.7a2.303 2.303 0 0 0 2.303-2.303h-3c0-.385.312-.697.697-.697zm2.303-2.303A2.303 2.303 0 0 0 12 13.094v3a.697.697 0 0 1-.697-.697zM12 13.094a2.303 2.303 0 0 0-2.303 2.303h3a.697.697 0 0 1-.697.697z"
            mask="url(#ursa-icon__ExclamationAlertErrorIcon__24__ida)"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
